import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'lib/redux'

const getUsers = (state: RootState) => state.users

export const usersSelector = createSelector(getUsers, (percentiles) => percentiles)

